export default __webpack_public_path__ + "static/media/banner-news.672ccab5.jpg";